import { render } from "./googleAutocomplete.vue?vue&type=template&id=1b53571b&ts=true"
import script from "./googleAutocomplete.vue?vue&type=script&lang=ts"
export * from "./googleAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__